// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.session.ProxyConfiguration
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { ProxyServiceInfo } from "abweb/dto/generated/session/ProxyServiceInfo";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class ProxyConfiguration {
  static createProxyConfiguration(proxyServiceInfo) {
    const retVal = new ProxyConfiguration();
    retVal.initProxyConfiguration(proxyServiceInfo);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createProxyConfiguration factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawads.ProxyConfiguration";
  }
  initFromJson(json, deserializeContext) {
    this.initProxyConfiguration(json.proxyServiceInfo != null ? TSOGUtils.decodeObjectArray(json.proxyServiceInfo, ProxyServiceInfo, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "proxyServiceInfo")) : null);
  }
  initProxyConfiguration(proxyServiceInfo) {
    this._proxyServiceInfo = proxyServiceInfo;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["proxyServiceInfo"] = TSOGUtils.toTSOGArray(this._proxyServiceInfo, serializeContext);
    return retVal;
  }
  get proxyServiceInfo() {
    return this._proxyServiceInfo;
  }
  set proxyServiceInfo(value) {
    this._proxyServiceInfo = value;
  }
}
//# sourceMappingURL=ProxyConfiguration.js.map
